import type * as React from "react";
import loadable from "./lazy_loader";

type Props = {
  children?: React.ReactNode;
  components?: Record<string, any>;
};

function LinkRenderer(props: { children: React.ReactNode; href: string }) {
  return (
    <a
      href={props.href}
      target="_blank"
      rel="noreferrer noopener"
      onClick={(ev) => {
        ev.stopPropagation();
      }}
    >
      {props.children}
    </a>
  );
}

const ReactMarkdown = loadable<Props>(
  () => import("react-markdown") as Promise<any>,
  // If react-markdown cannot be loaded, fall back to rendering the raw markdown text
  // as this is less intrusive than rendering an error message.
  ({ children }) => <>{children}</>,
);

export default function Markdown({ children, components }: Props) {
  return <ReactMarkdown components={{ ...components, a: LinkRenderer }}>{children}</ReactMarkdown>;
}
